import { PreviewTable } from './components';
import { useRecordsTable } from './hooks/useRecordsTable.ts';

interface IRecordsTableProps {
  groupName?: string;
  footerWidth?: string | number;
  isLoading?: boolean;
}

export const RecordsTable = ({
  groupName,
  footerWidth,
  isLoading,
}: IRecordsTableProps) => {
  const {
    entries,
    columns,
    totalCount,
    isLoading: loading,
    filters,
    onFilterChange,
  } = useRecordsTable(groupName);

  return (
    <PreviewTable
      rows={entries}
      columns={columns}
      filters={filters}
      setFilters={onFilterChange}
      totalCount={totalCount}
      loading={isLoading || loading}
      type='records'
      displayHead={groupName === undefined}
      footerWidth={footerWidth}
    />
  );
};
